import script from "./intro.vue?vue&type=script&setup=true&lang=js"
export * from "./intro.vue?vue&type=script&setup=true&lang=js"

import "./intro.vue?vue&type=style&index=0&id=035e15bf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-035e15bf"]])

export default __exports__